import './App.css';
import styled, { ThemeProvider } from 'styled-components';
import {darkTheme} from "./utils/Themes";
import Hero from "./components/HeroSection";
import Skills from "./components/Skills";
import Experience from "./components/Experience"
import Navbar from "./components/Navbar";
import Education from "./components/Education";
import Projects from "./components/Projects";
import { BrowserRouter as Router} from "react-router-dom";
// import Contact from "./components/Contact";
import Footer from "./components/Footer";


const Body = styled.div`
background-color: ${({theme})=> theme.bg};
width: 100%;
height:100%;
overflow-x: Hidden;
`;

const Wrapper = styled.div`
background: hsla(43, 100%, 52%, 1);

background: radial-gradient(circle, hsla(43, 100%, 52%, 1) 0%, hsla(240, 16%, 13%, 1) 0%);

background: -moz-radial-gradient(circle, hsla(43, 100%, 52%, 1) 0%, hsla(240, 16%, 13%, 1) 0%);

background: -webkit-radial-gradient(circle, hsla(43, 100%, 52%, 1) 0%, hsla(240, 16%, 13%, 1) 0%);

filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#FFBA08", endColorstr="#1C1C27", GradientType=1 );
`

function App() {
  return (
   <ThemeProvider theme={darkTheme}>
      <Router>
         <Navbar />
       <Body>
        <Hero/>
        <Wrapper>
          <Skills/>
          <Experience/>
        </Wrapper>
        <Projects/>
        <Wrapper>
          <Education/>
          {/* <Contact /> */}
        </Wrapper>
        <Footer />
          
       </Body>
      </Router>
      
    </ThemeProvider>
  );
}

export default App;
